import { jsxs as n, jsx as a } from "react/jsx-runtime";
import { clsx as C } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { useState as q } from "react";
import { Breakpoints as z } from "../../style/base/index.js";
import { useBreakpointMatch as J } from "../../utils/use-breakpoint-match.js";
import { useScrollDirection as K } from "../../utils/use-scroll-direction.js";
import { useScrollLock as P } from "../../utils/use-scroll-lock.js";
import { useScrollPosition as Q } from "../../utils/use-scroll-position.js";
import { RocheUIIcon as i } from "../icon/roche-icon.js";
import { RocheUIMainNavigation as U } from "../main-navigation/roche-main-navigation.js";
import { RocheUIMetaNavigation as V } from "../meta-navigation/roche-meta-navigation.js";
import { RocheUIMobileNavigation as X } from "../mobile-navigation/roche-mobile-navigation.js";
import e from "./roche-header.module.scss.js";
const Y = 100, le = ({
  homeLink: o,
  searchLink: t,
  worldWideLink: r,
  openNavLabel: x,
  closeNavLabel: g,
  currentPage: l,
  isFixed: m,
  primaryNav: d,
  secondaryNav: h,
  primaryNavLabel: M,
  secondaryNavLabel: R,
  skipToContentLabel: S,
  onSkipToContent: p,
  languageSwitchConfig: _,
  logoIconUrl: s
}) => {
  const [c, b] = q(!1), D = J(z.MEDIUM), B = !!s && (s == null ? void 0 : s.toLowerCase()) !== "default", H = () => B ? (
    // alt-text is intentionally left empty to avoid duplicate information for screen readers, as the logo is already described by the home-link's aria-label
    /* @__PURE__ */ a("img", { className: e["header__logo-image"], src: s, fetchPriority: "high", alt: "" })
  ) : /* @__PURE__ */ a(i, { icon: "logo", height: D ? "30px" : "40px", decorative: !0 });
  P(c);
  const O = () => {
    b(!c);
  }, u = Q(), y = K(), f = u > 0, I = u < Y, j = !m && !I && y === "down", E = !f, T = C(
    e.header,
    m && e["header--fixed"],
    f && e["header--scrolled"],
    E && e["header--transparent"],
    j && e["header--hidden"]
  ), v = l === (t == null ? void 0 : t.url), A = () => r != null && r.url ? /* @__PURE__ */ a(
    "a",
    {
      href: r.url,
      className: e.header__worldwide,
      onClick: r.onClick,
      "aria-label": r.label,
      children: N()
    }
  ) : /* @__PURE__ */ a(
    "button",
    {
      className: e.header__worldwide,
      type: "button",
      onClick: r == null ? void 0 : r.onClick,
      "aria-label": r == null ? void 0 : r.label,
      children: N()
    }
  ), N = () => /* @__PURE__ */ a("span", { className: e["header__worldwide-icon"], children: /* @__PURE__ */ a(i, { icon: "globe-mobile", height: "32px", width: "32px", decorative: !0 }) });
  return /* @__PURE__ */ n("header", { className: T, children: [
    /* @__PURE__ */ a(
      "a",
      {
        className: e["header__skip-link"],
        href: "#main-content",
        onClick: (G) => {
          p && (G.preventDefault(), p());
        },
        children: S
      }
    ),
    /* @__PURE__ */ n("div", { className: e["header__first-row"], children: [
      /* @__PURE__ */ a(
        "a",
        {
          className: e["header__logo-link"],
          href: (o == null ? void 0 : o.url) ?? "/",
          "aria-label": o == null ? void 0 : o.label,
          onClick: o == null ? void 0 : o.onClick,
          children: /* @__PURE__ */ a("span", { className: e.header__logo, children: H() })
        }
      ),
      /* @__PURE__ */ a("div", { className: e["header__secondary-nav"], children: /* @__PURE__ */ a(
        V,
        {
          nav: h,
          secondaryNavLabel: R,
          worldWideLink: r,
          searchLink: t,
          currentPage: l,
          languageSwitchConfig: _
        }
      ) }),
      /* @__PURE__ */ n("div", { className: e.header__actions, children: [
        r && A(),
        /* @__PURE__ */ a(
          "a",
          {
            href: t == null ? void 0 : t.url,
            className: C(e.header__search, v && e["header__search--active"]),
            "aria-label": t == null ? void 0 : t.label,
            "aria-current": v ? "page" : void 0,
            onClick: t == null ? void 0 : t.onClick,
            children: /* @__PURE__ */ a("span", { className: e["header__search-icon"], children: /* @__PURE__ */ a(i, { icon: "search-mobile", height: "32px", decorative: !0 }) })
          }
        ),
        /* @__PURE__ */ a(
          "button",
          {
            className: e.header__burger,
            onClick: O,
            "aria-label": x,
            "aria-controls": "mobile-navigation",
            "aria-expanded": c,
            type: "button",
            children: /* @__PURE__ */ a("span", { className: e["header__burger-icon"], children: /* @__PURE__ */ a(i, { icon: "mobile-menu", height: "32px", decorative: !0 }) })
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ a("div", { className: e["header__second-row"], children: /* @__PURE__ */ a(U, { nav: d, primaryNavLabel: M, currentPage: l }) }),
    /* @__PURE__ */ a("div", { className: e["header__mobile-nav"], children: /* @__PURE__ */ a(
      X,
      {
        primaryNav: d,
        secondaryNav: h,
        closeNavLabel: g,
        currentPage: l,
        isNavOpen: c,
        setIsNavOpen: b,
        languageSwitchConfig: _
      }
    ) })
  ] });
};
export {
  le as RocheUIHeader
};
